import { CommonModule } from "@angular/common";
import { Component, ViewEncapsulation, OnInit } from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from "@angular/router";
import { HeaderComponent } from "../../shared/header/header";
import { AppProgressComponent } from "../../shared/progress/progress";
import { filter, map, Subscription, Observable } from "rxjs";
import { RequestTitleService } from "../../../services/shared/requset-title.service";
import { HomeHeaderComponent } from "../home/home-header/home-header/home-header.component";

@Component({
    selector: 'mi-request',
    imports: [RouterOutlet,
        HeaderComponent,
        CommonModule,
        AppProgressComponent,
        HomeHeaderComponent
    ],
    templateUrl: './request.html',
    styleUrl: './request.scss',
    encapsulation: ViewEncapsulation.None
})
export class RequestComponent implements OnInit {

    isNeedProgress: boolean = false;
    isNeedMainHeader: boolean = false;
    requestTitle$: Observable<string> = new Observable();
    subscriptions: Subscription = new Subscription();

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private requestTitleService: RequestTitleService,
    ) { }

    ngOnInit() {
        this.subscribeRoute();
        this.initText();
    }

    initText() {
        this.requestTitle$ = this.requestTitleService.getFormatRequestTitleText();
    }

    subscribeRoute() {
        this.router.events.pipe(
            filter((event) => event instanceof NavigationEnd),
            map(() => this.activatedRoute),
            map((route) => {
                while (route.firstChild) {
                    route = route.firstChild;
                }
                return route;
            }),
            filter((route) => route.outlet === 'primary'),
            map((route) => route.snapshot.data)
        ).subscribe((data) => {
            this.isNeedProgress = data['stepCondition'];
            this.isNeedMainHeader = data['isVisibleMainHeader'];
        });
    }

    isHomePage(): boolean {
        return this.router.url === '/';
    }
}